export default __webpack_public_path__ + "static/media/2.988f7308.jpg";